export default function Zones() {
  const zones = [
    {
      name: 'Saly',
      description: 'Zone prioritaire avec couverture complète et équipe dédiée sur place.',
      priority: true
    },
    {
      name: 'Somone',
      description: 'Intervention régulière dans cette zone touristique prisée.',
      priority: false
    },
    {
      name: 'Ngaparou',
      description: 'Service complet pour les propriétés résidentielles et de villégiature.',
      priority: false
    },
    {
      name: 'Petite Côte',
      description: 'Extension progressive de nos services sur l\'ensemble de la région.',
      priority: false
    }
  ];

  return (
    <section id="zones" className="py-20 md:py-32 bg-[#1A3B5C] text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://public.readdy.ai/ai/img_res/6265aacb598e2be1a2a92a4557e0ad4c.jpg"
          alt="Carte"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          <div className="md:col-span-2">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Où Nous Intervenons
            </h2>
            <p className="text-lg text-white/90 leading-relaxed mb-6">
              AMD Gestion Immobilière couvre actuellement les principales zones de la Petite Côte, avec une présence renforcée à Saly.
            </p>
            <div className="inline-flex items-center space-x-2 bg-[#C9A961] px-4 py-2 rounded-full">
              <i className="ri-map-pin-add-line text-white"></i>
              <span className="text-white font-semibold text-sm">Extension Progressive</span>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="grid md:grid-cols-2 gap-4">
              {zones.map((zone, index) => (
                <div
                  key={index}
                  className={`bg-white rounded-xl p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 ${
                    zone.priority ? 'md:col-span-2 border-2 border-[#C9A961]' : ''
                  }`}
                >
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center space-x-3">
                      <i className="ri-map-pin-line text-[#C9A961] text-3xl"></i>
                      <h3 className="text-2xl font-bold text-[#1A3B5C]">
                        {zone.name}
                      </h3>
                    </div>
                    {zone.priority && (
                      <span className="bg-[#C9A961] text-white px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap">
                        Zone Prioritaire
                      </span>
                    )}
                  </div>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {zone.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <p className="text-white/80 text-lg">
            Votre zone n'est pas listée ? Contactez-nous pour discuter de vos besoins spécifiques.
          </p>
        </div>
      </div>
    </section>
  );
}
